import './App.css';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { checkAuth } from './redux/slices/authSlice';
import { Button } from './components/ui/button';
import { getCookie, setCookie } from './utils/cookies';
import { Route, Routes, useLocation } from 'react-router-dom';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from './components/ui/dialog';
import { AlertCircle } from 'lucide-react';
import ProtectedRoute from './components/route-wrappers/ProtectedRoute';
import { DashboardPageLayout } from './components/layouts/DashboardPageLayout';
import {
  BONUSES,
  CLASSES,
  HOME_ROUTE,
  LOGIN_ROUTE,
  PURCHASE_HISTORY,
  REGISTRATION_ROUTE,
  SIGN_UP,
  SWIMMERS_DIARY,
  TEST_ERROR_ROUTE,
  TICKETS,
  VISITS_HISTORY,
  CERTIFICATES,
  FILEUPLOADER,
} from './utils/const';
import Home from './pages/Home';
import SignUp from './pages/SignUp';
import Classes from './pages/Classes';
import Auth from './pages/Auth';
import TestError from './pages/TestError';
import AuthRoute from './components/route-wrappers/AuthRoute';
import NotFoundRoute from './components/route-wrappers/NotFoundRoute';
import Tickets from './pages/Tickets';
import PurchaseHistory from './pages/PurchaseHistory';
import Bonuses from './pages/Bonuses';
import VisitsHistory from './pages/VisitsHistory';
import SwimmersDiary from './pages/SwimmersDiary';
import Certificates from './pages/Certificates';
import FileUploader from './pages/FileUploader';
function App() {
  const location = useLocation();
  const { isAuth } = useSelector((state: any) => state.auth);
  const logoutCheck = useSelector((state: any) => state.interfaceApp.logoutCheck);
  const dispatch = useDispatch();
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);
  const [showConnectionDialog, setShowConnectionDialog] = useState<boolean>(false);
  const [isAuthCheck, setIsAuthCheck] = useState<boolean>(isAuth);
  useEffect(() => {
    const isAuthCookie = getCookie('isAuth');
    setIsAuthCheck(true);
    if (isAuthCookie === 'true') {
      dispatch(checkAuth(true));
    }
    if (localStorage.getItem('id_filail') && location.pathname !== '/login') {
      setCookie('isAuth', 'false');
      localStorage.clear();
      window.location.reload();
    }
  }, []);
  useEffect(() => {
    if (location.pathname === '/login') {
      setIsAuthCheck(false);
    } else if (location.pathname === '/home') {
      setIsAuthCheck(true);
    }
  }, [location.pathname]);
  useEffect(() => {
    setIsMenuOpen(false);
  }, [logoutCheck]);

  window.onbeforeunload = () => {
    if (!isAuth) {
      setCookie('isAuth', 'false');
    }
  };
  useEffect(() => {
    if (isAuthCheck && !logoutCheck) {
      setShowConnectionDialog(true);
      setCookie('isAuth', 'false');
    }
  }, [localStorage.getItem('id')]);

  const handleReconnect = () => {
    setShowConnectionDialog(false);
    setCookie('isAuth', 'false');
    window.location.reload();
  };

  return (
    <div className="wrapper">
      <div className="relative mr-auto w-full max-w-[1280px]">
        <Routes>
          {/* Dashboard routes that require authentication */}
          <Route element={<ProtectedRoute />}>
            <Route
              element={
                <DashboardPageLayout isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
              }>
              <Route path={HOME_ROUTE} element={<Home />} />
              <Route path={SIGN_UP} element={<SignUp />} />
              <Route path={CLASSES} element={<Classes />} />
              <Route path={TICKETS} element={<Tickets />} />
              <Route path={PURCHASE_HISTORY} element={<PurchaseHistory />} />
              <Route path={BONUSES} element={<Bonuses />} />
              <Route path={VISITS_HISTORY} element={<VisitsHistory />} />
              <Route path={SWIMMERS_DIARY} element={<SwimmersDiary />} />
              <Route path={CERTIFICATES} element={<Certificates />} />
              <Route path={FILEUPLOADER} element={<FileUploader />} />
            </Route>
          </Route>

          {/* Routes that do not require authentication */}
          <Route element={<AuthRoute />}>
            <Route path={LOGIN_ROUTE} element={<Auth />} />
            <Route path={REGISTRATION_ROUTE} element={<Auth />} />
          </Route>

          {/* Test error route - accessible regardless of auth status */}
          <Route path={TEST_ERROR_ROUTE} element={<TestError />} />

          {/* Handle 404 errors */}
          <Route path="*" element={<NotFoundRoute />} />
        </Routes>
      </div>

      {/* Connection lost dialog */}
      <Dialog open={showConnectionDialog} onOpenChange={() => {}}>
        <DialogContent className="sm:max-w-[425px]">
          <DialogHeader className="flex flex-col items-center gap-2">
            <div className="rounded-full bg-red-50 p-3">
              <AlertCircle className="h-6 w-6 text-red-500" />
            </div>
            <DialogTitle className="text-xl">Потеря соединения</DialogTitle>
            <DialogDescription className="text-center text-gray-500">
              Связь с сервером была потеряна. Нажмите OK для переподключения.
            </DialogDescription>
          </DialogHeader>
          <DialogFooter className="mt-4">
            <Button onClick={handleReconnect} className="w-full bg-red-500 hover:bg-red-600">
              OK
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default App;
